import * as entity from '@common/domain/entities/RoleWarehouse'
import { IColumnOptions, IDataEndPoint } from '../../../framework/interfaces/IEntity';
import * as app from '@framework/app';
import { IApiServiceCommand } from '../../../services/api/api.service';
import { FieldType } from '../../../framework/core/Enums';

export class RoleWarehouseEndPoints extends entity.RoleWarehouseEndPoints {
  list?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/role/roleWarehouses/" + serviceCommand.context.entityId
    }
  };
  insert?: IDataEndPoint = {
    url: app.config.controllerRouteRoot + "/role/addWarehouse",
    //url: app.config.controllerRouteRoot + "/user/addRole?userId={context.parent.parent.selectedItem.id}&roleId={serviceCommand.data.id}&organisationId={serviceCommand.data.organisationId}",
    params: function (serviceCommand: IApiServiceCommand): object {
      return {
        warehouseId: serviceCommand.data.id,
        roleId: serviceCommand.context.entityId
      }
    },
    method: "POST"
  };
  delete?: IDataEndPoint = {
    url: app.config.controllerRouteRoot + "/role/removeWarehouse",
    //url: app.config.controllerRouteRoot + "/user/removeRole?userId={context.parent.parent.selectedItem.id}&roleId={serviceCommand.data.id}&organisationId={serviceCommand.data.organisationId}",
    params: function (serviceCommand: IApiServiceCommand): object {
      return {
        warehouseId: serviceCommand.data.id,
        roleId: serviceCommand.context.entityId
      }
    },
    method: "POST"
  };
  search?: IDataEndPoint = null;
}

export class RoleWarehouseFormFields extends entity.RoleWarehouseFormFields {
  constructor() {
    super();
	 try {
      if (this["id"]) this.splice(this.indexOf(this["id"]), 1)
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
      if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)
    } catch  { }
  }
}

export class RoleWarehouseForm extends entity.RoleWarehouseForm {
  protected roleWarehouseFormEndPoints: RoleWarehouseEndPoints = new RoleWarehouseEndPoints();
  protected roleWarehouseFormFields: RoleWarehouseFormFields = new RoleWarehouseFormFields();
}

export class RoleWarehouseListColumns extends entity.RoleWarehouseListColumns {
  constructor() {
    super();
    try {
      if (this["id"]) this["id"].visible = false;
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
      if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)
      this.splice(0, this.length);
      var selected: IColumnOptions = { field: "selected", width: "140px", fieldType: FieldType.Byte, name: "Selected" };
      var name: IColumnOptions = { field: "name", fieldType: FieldType.String, name: "Name", };
      selected.readOnly = false;
      selected.endPoints = new RoleWarehouseEndPoints();
      this.push(selected)
      this.push(name)
    } catch  { }

  }
}

export class RoleWarehouseList extends entity.RoleWarehouseList {
  protected roleWarehouseListEndPoints: RoleWarehouseEndPoints = new RoleWarehouseEndPoints();
  protected roleWarehouseListColumns: RoleWarehouseListColumns = new RoleWarehouseListColumns();
}
